export default "__VITE_ASSET__00b25b9f__$_?component__"